import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  hideMessage,
  showAuthLoader,
  userSignIn
} from 'actions/Auth';
import "babel-polyfill";
import {Alert} from 'reactstrap';

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      emailErrorText:'',
      passwordErrorText:'',
    }

    if(process.env.REACT_APP_ENV ==="development"){
      this.state = {
        email: 'nakdag4@ayk.gov.tr',
        password: '123456',
      }
     }
  }

  validate = ()=>{
    let isError = false;
    const errors = {};
   
    if(this.state.email.length < 1){
      isError = true;
      errors.emailErrorText = "E-Posta Adresi veya TC Kimlik No alanı zorunludur."
    }
    if(this.state.password.length < 6){
      isError = true;
      errors.passwordErrorText = "Şifre alanı zorunludur. En az 6 karakter."
    }
    if(isError){
      this.setState({
        ...this.state,
        ...errors
      })
    }

    return isError;
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.authUser !== null) {
      this.props.history.push('/');
    }
  }

  render() {
    const {
      email,
      password
    } = this.state;
    const {showMessage, loader, alertMessage} = this.props;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
  //  console.log("İs Internet Explorer :",isIE)
    return (
      <div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">

        
{/* <div className="app-logo-content d-flex justify-content-center">
<h2 className="white">Türk Masal Külliyatı - I</h2>
</div> */}

          <div className="app-logo-content d-flex align-items-center justify-content-center">

         
           
           

            <Link className="row" to="/" title="Tümak">
              <img src={require("assets/images/tumak-logo/logo-buyuk6.png")} alt="Tümak" title="Tümak"/>
            </Link>
{/* 
            <h1  className="row">Masal Masal Türkiye</h1> */}
            
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1><IntlMessages id="appModule.signIn"/></h1>
            </div>

            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={"E-Posta Adresiniz veya TC Kimlik Numaranız"}
                    fullWidth
                    onChange={(event) => this.setState({email: event.target.value , emailErrorText:""})}
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    error= {this.state.emailErrorText === "" ? false : true }   
                    helperText={this.state.emailErrorText}
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password"/>}
                    fullWidth
                    onChange={(event) => this.setState({password: event.target.value , passwordErrorText:""})}
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    error= {this.state.passwordErrorText === "" ? false : true }  
                    helperText={this.state.passwordErrorText} 
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button onClick={() => {

                      const err = this.validate();
                      if(!err)
                      {
                        this.props.showAuthLoader();
                      this.props.userSignIn({email, password});
                      }

                    }} variant="contained" color="primary">
                      GİRİŞ YAP
                    </Button>

                         
                  
                    
                  </div>
                  <div className="mb-3 d-flex align-items-right justify-content-between">
                          <Link to="/signup">
                                                <IntlMessages id="signIn.signUp"/>
                                              </Link>
                                              
                                              <Link to="/forgotMyPassword">
                                                <IntlMessages id="signIn.forgotMyPassword"/>
                                              </Link>
                          </div>

                  <div className="app-social-block my-1 my-sm-3">
                  
                  </div>
                  <div className="app-social-block my-1 my-sm-3">
                    {
                      isIE ? 
                      <Alert className="shadow-lg" color="danger">
                      Not: Uygulamanın sorunsuz çalışabilmesi için lütfen Chrome, 
                      Firefox, Safari veya Edge gibi güncel tarayıcı kullanın. Internet Explorer'ın eski versiyonlarında düzgün çalışmayabilir.
                      </Alert>
                      : null
                    }
                 
                  </div>
                </fieldset>
              </form>
            </div>
          </div>

         
        </div>
        {
          loader &&
          <div className="loader-view">
            <CircularProgress/>
          </div>
        }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer/>
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser,userName} = auth;
  return {loader, alertMessage, showMessage, authUser,userName}
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader
})(SignIn);
